import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";

import {
  PoNotificationService,
  PoTableAction,
  PoComboOption,
  PoTableColumn,
  PoModalComponent,
  PoModalAction,
  PoRadioGroupOption,
} from "@po-ui/ng-components";
import { Router, ActivatedRoute } from "@angular/router";
import { OrcamentoViewService } from "./orcamento-view.service";
import { Impostos } from "./imposto";
import { OrcamentoFormService } from "../orcamento-form/orcamento-form.service";
import { firstValueFrom, forkJoin, from, Observable, of } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { NgForm } from "@angular/forms";
import * as Papa from 'papaparse';
import { ImportacaoService } from "../orcamento-form/importacao";
import { OrcamentoStatus } from "../orcamento-status.enum";

@Component({
  selector: "app-orcamento-view",
  templateUrl: "./orcamento-view.component.html",
  styleUrls: ["./orcamento-view.component.css"],
  standalone: false,
})

export class OrcamentoViewComponent implements OnInit {
  codigoOrcamento: string;
  valorMinimo: number = 500;
  columns: Array<PoTableColumn>;
  items: Array<any>;

  produtoColumns: Array<PoTableColumn>;
  produtoItems: Array<any>;

  columnsSimilar: Array<PoTableColumn>;
  itemsSimilar: Array<any> = new Array();

  labelTitulo: string;

  readonly BuscaOptions: Array<PoRadioGroupOption> = [
    { label: "Início do texto", value: "I" },
    { label: "Contém texto", value: "" },
    { label: "Final do texto", value: "F" },
  ];

  status: string;
  data: Date = new Date();
  emissao: Date;
  options: Array<any> = new Array();
  optionsCod: Array<any> = new Array();
  produtoSelect: string;
  CodigoProdutoSelect: string;
  produto: string;
  produtoTemp: string;
  existeNaGrade = false;
  clienteSelect: string;
  TpFreteSelect: string;
  optionsProdutos: Array<any> = new Array();
  quantidade: number;
  quantidadeTemp: number;
  name: string;
  email: string;
  ie: string;
  fone: string;
  endereco: string;
  um: string;
  subTotal = 0;
  ipi = 0;
  icms = 0;
  vlrFrete = 0;
  desconto: number;
  total = 0;
  qtdTotal = 0;
  precoUni: number;
  cabOrcamento: Array<any> = new Array();
  informaTransp: boolean;
  id: String;
  transOptions: Array<PoComboOption>;
  transportadorSelect: String;
  condPgOptions: Array<any> = new Array();
  CondpgSelect: String;
  observacao: String;
  transportadorasOp: Array<any> = new Array();
  vendaFutura: String;
  isHideLoading = false;
  impostos;
  _impostos: any;
  tabprc: any;
  descontoCli: number;
  SalvarVoltar = "Salvar";

  listaCliente: any;
  segmento: string;
  nome: string;
  codigo: string;
  produtoFiltro: string;
  altera = true;
  isPecas: boolean;
  indexAltera: number;

  saldoEstoque: number;
  length: number;

  tpconsulta: string;

  itensAlterarcao: Array<any> = new Array();

  actions: Array<PoTableAction> = [
    {
      action: this.alterar.bind(this),
      icon: "po-icon po-icon-edit",
      label: "Alterar",
    },
    {
      action: this.remover.bind(this),
      icon: "po-icon po-icon-delete",
      label: "Excluir",
    },
  ];

  actionsProdutos: Array<PoTableAction> = [
    {
      action: this.addProduto.bind(this),
      icon: "po-icon po-icon-plus-circle",
      label: "Adicionar",
    },
  ];
  copyItems: any[];
  pohelp: string;

  constructor(
    private OrcamentoViewService: OrcamentoViewService,
    private poNotification: PoNotificationService,
    private router: Router,
    private route: ActivatedRoute,
    private orcamentoFormService: OrcamentoFormService,
    public importacaoService: ImportacaoService
  ) {
    this.route.params.subscribe(
      (params) => (this.codigoOrcamento = params["id"])
    );
  }

  @ViewChild(PoModalComponent, { static: true }) poModal: PoModalComponent;
  @ViewChild("AddProduto", { static: true }) AddProduto: PoModalComponent;
  @ViewChild("AlteraProduto", { static: true }) AlteraProduto: PoModalComponent;
  @ViewChild('formOrcamento') formOrcamento!: NgForm;
  @ViewChild('csvInput') csvInput: ElementRef<HTMLInputElement>;

  csvData: any[] = [];

  async ngOnInit() {
    this.isHideLoading = false;
    this.isPecas = sessionStorage.getItem("Segmento") === "PECAS";
    this.columns = this.OrcamentoViewService.getColumns();
    this.segmento = sessionStorage.getItem("Segmento");
    this.informaTransp = true;
    this.isHideLoading = true;
    this.produtoColumns = this.OrcamentoViewService.getProdutosColumns();
    this.columnsSimilar = this.OrcamentoViewService.getSimilarColumns();
    this.OrcamentoViewService.getValorMinimo().subscribe({
      next: (data) => {
        if (data) {
          const val = parseFloat(data.descricao || data.CONTEUDO || data.valor || data);
          if (!isNaN(val) && val > 0) {
            this.valorMinimo = val;
            sessionStorage.setItem("valorMinimoOrcamento", val.toString());
          }
        }
      },
      error: () => {
        const cached = sessionStorage.getItem("valorMinimoOrcamento");
        if (cached) {
          this.valorMinimo = parseFloat(cached) || 500;
        }
      }
    });

    await this.carregaCabecalho();
    await this.carregaItens();
    this.tpconsulta = "I";
    this.isHideLoading = true;

  }

  async carregaCabecalho() {
    try {
      this.condPgOptions = await this.getOptCondPagamentos();

      const CabOrcamento = await firstValueFrom(
        this.OrcamentoViewService.getCabOrcamento(parseInt(this.codigoOrcamento))
      );

      this.isHideLoading = false;
      this.emissao = new Date(CabOrcamento.emissao.replace("Z", ""));
      this.id = ("0000" + this.codigoOrcamento).slice(-4);
      this.status = CabOrcamento.status;
      this.observacao = CabOrcamento.observacao;
      this.CondpgSelect = CabOrcamento.condPagamento;
      this.isHideLoading = true;

      if (!(this.status === OrcamentoStatus.EM_ELABORACAO || this.status === OrcamentoStatus.EM_EDICAO || this.status === OrcamentoStatus.LIMITE_NAO_ATINGINDO)) {
        this.altera = false;
        this.SalvarVoltar = "Voltar";
      }
    } catch (error) {
      console.error("Erro ao carregar cabeçalho do orçamento:", error);
    }

    //Espera os valores serem validados
    setTimeout(() => {
      this.formOrcamento?.form.updateValueAndValidity();
    });
  }


  async carregaItens() {
    this.subTotal = 0;
    this.total = 0;
    this.ipi = 0;
    this.icms = 0;
    this.items = [];
    this.isHideLoading = false;

    await this.OrcamentoViewService.getItensOrcamento(
      parseInt(this.codigoOrcamento)
    ).subscribe((itens) => {
      itens.forEach((itens: { id: any; item: number; quantidade: number; DescProduto: string; codProduto: string; prcUnitario: number; precoImposto: number; un: string; valorDesconto: number; ipi: number; icms: number; qtdLiberada: any; }) => {
        this.items.push(
          this.OrcamentoViewService.generateNewItem(
            itens.id,
            itens.item,
            itens.quantidade,
            itens.DescProduto,
            itens.codProduto,
            Math.round(itens.prcUnitario * 100),
            Math.round(itens.precoImposto * 100),
            itens.un,
            Math.round(itens.valorDesconto * 100),
            Math.round(itens.ipi * 100),
            Math.round(itens.icms * 100),
            itens.qtdLiberada
          )
        );
        this.updateTotais();
        this.isHideLoading = true;
      });
    });
    //this.isHideLoading = true;
  }

  async getOptCondPagamentos(): Promise<PoComboOption[]> {
    this.condPgOptions = [];

    try {
      const filter = sessionStorage.getItem("cpg")?.split("|") || [];
      const condicoes = await firstValueFrom(this.orcamentoFormService.getcondPagamentos(filter));

      this.condPgOptions = condicoes.map(condicao => ({
        label: condicao.nome,
        value: condicao.codigo,
      }));

      return this.condPgOptions;
    } catch (error) {
      console.error("Erro ao carregar condições de pagamento:", error);
      return [];
    }
  }

  updateTotais() {
    //  var valorFrete = this.vlrFrete > 0 ? this.vlrFrete : 0;
    this.total = 0;
    this.subTotal = 0;
    this.ipi = 0;
    this.icms = 0;
    this.qtdTotal = 0;
    //console.log(this.items);
  
    this.items.forEach( item =>{
      this.subTotal += item.vlruni * item.quantity;
      this.total += item.total;
      this.ipi += item.ipi * item.quantity;
      this.icms += item.icms * item.quantity;
      this.qtdTotal += item.quantity;
    })
  }

  closeModal() {
    this.poModal.close();
  }

  close: PoModalAction = {
    action: () => {
      this.closeModal();
    },
    label: "Cancelar",
    danger: true,
  };

  confirm: PoModalAction = {
    action: () => {
      this.closeModal();
    },
    label: "Voltar",
  };

  AddProdutoBotao: PoModalAction = {
    action: () => {
      if (
        sessionStorage
          .getItem("cpcred")
          .indexOf(this.CondpgSelect.toString()) != -1
      ) {
        this.tabprc = sessionStorage.getItem("tabesp");
      } else {
        this.tabprc = sessionStorage.getItem("tabprc");
      }

      if (this.altera) {
        this.isHideLoading = false;
        if (this.quantidade > 0) {
          let existe = false;
          for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].code === this.CodigoProdutoSelect) {
              existe = true;
            }
          }
          if (!existe) {
            this.AddProduto.close();
            this.closeModal();
            this.OrcamentoViewService.getPreco(
              this.tabprc,
              this.CodigoProdutoSelect,
              this.segmento
            ).subscribe(async (preco) => {
              if (preco.length > 0) {
                await this.retImpostos(
                  this.CodigoProdutoSelect,
                  preco[0].precoTabela,
                  this.quantidade
                );

                if (this._impostos === undefined || this._impostos.length === 0) {
                  throw new Error("Não foi possível carregar os impostos, solicite revisão no cadastro desse produto.");
                }

                if (this._impostos[0].PRODUTO == "NON") {
                  this.poNotification.error(
                    "Não foi possível carregar os impostos, por favor, logue outra vez e tente novamente."
                  );
                } else {
                  this.items.push(
                    this.orcamentoFormService.generateNewItem(
                      this.items.length + 1,
                      this.quantidade,
                      this.produto,
                      this.CodigoProdutoSelect,
                      Math.round(preco[0].precoTabela * 100),
                      Math.round(this._impostos[0].TOTAL * 100),
                      this.um,
                      Math.round(this.desconto * 100),
                      Math.round(this._impostos[0].IPI * 100),
                      Math.round(this._impostos[0].ICMS * 100),
                      // this._impostos[0].TOTAL * quantidadeTemp
                    )
                  );
                  this.updateTotais();
                }
                this.AddProduto.close();
              } else {
                this.poNotification.error(
                  "Produto indisponível, consultar área comercial"
                );
                this.AddProduto.close();
                this.closeModal();
              }
              //    this.closeModal();
              //   this.poNotification.success("Produto adicionado com sucesso!");
            });
          } else {
            this.poNotification.error("Produto adicionado anteriormente!");
            this.AddProduto.close();
            this.closeModal();
          }
        } else {
          this.AddProduto.close();
        }
        this.isHideLoading = true;
      } else {
        this.AddProduto.close();
        this.closeModal();
        this.poNotification.error(
          "Operação negada, orçamento efetivado anteriormente"
        );
      }
    },
    label: "Confirmar",
  };

  attHelp() {
    this.copyItems = [];
    if (
      sessionStorage.getItem("cpcred").indexOf(this.CondpgSelect.toString()) !=
      -1
    ) {
      this.tabprc = sessionStorage.getItem("tabesp");
      this.pohelp = "* Com Acréscimo";
    } else {
      this.pohelp = " ";
      this.tabprc = sessionStorage.getItem("tabprc");
    }
    if (this.items.length > 0) {
      this.copyItems = this.items;
      this.items = [];
      for (let i = 0; i < this.copyItems.length; i++) {
        this.OrcamentoViewService.getPreco(
          this.tabprc,
          this.copyItems[i].code,
          this.segmento
        ).subscribe(async (preco) => {
          if (preco.length > 0) {
            await this.retImpostos(
              this.copyItems[i].code,
              preco[0].precoTabela,
              this.copyItems[i].quantity
            );

            if (this._impostos === undefined || this._impostos.length === 0) {
              throw new Error("Não foi possível carregar os impostos, solicite revisão no cadastro desse produto.");
            }

            if (this._impostos[0].PRODUTO == "NON") {
              this.poNotification.error(
                "Não foi possível carregar os impostos, por favor, logue outra vez e tente novamente."
              );
            } else {
              this.items.push(
                this.OrcamentoViewService.generateNewItem(
                  null,
                  this.copyItems.length + 1,
                  this.copyItems[i].quantity,
                  this.copyItems[i].product,
                  this.copyItems[i].code,
                  Math.round(preco[0].precoTabela * 100),
                  Math.round(this._impostos[0].TOTAL * 100),
                  this.copyItems[i].unidadem,
                  0,
                  Math.round(this._impostos[0].IPI * 100),
                  Math.round(this._impostos[0].ICMS * 100),
                  0
                )
              );
              this.updateTotais();
            }
          } else {
            this.poNotification.error(
              "Produto indisponível, consultar área comercial"
            );
          }
          //    this.closeModal();
          //   this.poNotification.success("Produto adicionado com sucesso!");
        });
      }
    }
  }

  async addProduto(item) {
    let similar: Array<any>;
    this.isHideLoading = false;
    this.quantidade = null;
    this.itemsSimilar = [];
    this.produtoSelect = item.codigo + " " + item.produto;
    this.CodigoProdutoSelect = item.codigo;
    this.produto = item.produto;
    this.um = item.un;
    await this.consultaSaldo(item.codigo);
    if (this.isPecas) {
      this.OrcamentoViewService.getSimilar(this.CodigoProdutoSelect).subscribe(
        (Similar) => {
          similar = Similar;
          for (let i = 0; i < similar.length; i++) {
            this.itemsSimilar.push(
              this.OrcamentoViewService.generateNewItemSimilar(
                similar[i].similar,
                similar[i].descricao
              )
            );
          }

          this.AddProduto.open();
        }
      );
    } else {
      this.AddProduto.open();
    }
    this.isHideLoading = true;
  }

  AlteraProdutoBotao: PoModalAction = {
    action: () => {
      if (this.altera) {
        if (this.quantidade > 0) {
          let index = this.indexAltera;
          this.items[index].quantity = this.quantidade;
          this.items[index].total =
            this.quantidade * this.items[index].vlruni_imp;
          if (this.items[index].id) {
            let indexExist = null;
            let existe = false;
            this.itensAlterarcao.forEach((produto, indexItens) => {
              if (produto.id == this.items[index].id) {
                indexExist = indexItens;
                existe = true;
              }
            });

            if (!existe) {
              this.itensAlterarcao.push({
                quantidade: this.items[index].quantity,
                idCab: parseInt(this.codigoOrcamento),
                id: parseInt(this.items[index].id),
                codProduto: this.items[index].code,
                valorTotal: this.items[index].total,
              });
            } else {
              this.itensAlterarcao[indexExist].quantidade =
                this.items[index].quantity;
              this.itensAlterarcao[indexExist].valorTotal =
                this.items[index].total;
            }

            this.updateTotais();
            this.AlteraProduto.close();
            this.poNotification.setDefaultDuration(1500);
            this.poNotification.success("Produto alterado");
          } else {
            this.updateTotais();
            this.AlteraProduto.close();
            this.poNotification.setDefaultDuration(1500);
            this.poNotification.success("Produto alterado");
          }
        } else {
          this.AlteraProduto.close();
        }
      } else {
        this.AlteraProduto.close();
        this.poNotification.error(
          "Operação negada, orçamento efetivado anteriormente"
        );
      }
    },
    label: "Confirmar",
  };

  BuscaProduto(): void {
    this.produtoItems = []; // reset visual
    if (this.produtoFiltro) {
      this.getOptProdutos(
        this.segmento,
        this.produtoFiltro,
        this.tpconsulta,
        sessionStorage.getItem("tabprc")
      );
    }
  }

  getOptProdutos(segmento, filtro, tpconsulta, tabprc): void {
    this.optionsProdutos = [];
    this.isHideLoading = false;
    this.produtoItems = [];

    this.OrcamentoViewService.getProdutos(segmento, filtro, tpconsulta, tabprc)
      .subscribe((Produtos) => {
        this.optionsProdutos = Produtos.map(p => ({
          codigo: p.codigo,
          produto: p.descricao,
          un: p.un,
        }));
        this.produtoItems = this.optionsProdutos; // <- popula aqui!
        this.isHideLoading = true;
      });
  }

  async addItem() {
    if (this.altera) {
      this.produtoFiltro = null;
      if (this.CondpgSelect) {
        this.poModal.open();
      } else {
        this.poNotification.error("Por favor, informe a condição de pagamento antes.");
      }
    } else {
      this.poNotification.error(
        "Operação negada, orçamento efetivado anteriormente"
      );
    }
  }

  async remover(item) {
    //this.subTotal -= this.items[this.items.indexOf(item)].total;
    this.isHideLoading = false;
    this.items.splice(this.items.indexOf(item), 1);
    //await this.recalculaImpostos();
    this.updateTotais();
    this.isHideLoading = true;
    this.poNotification.setDefaultDuration(1500);
    this.poNotification.error("Produto removido");
  }

  async alterar(item) {
    let similar: Array<any>;
    this.quantidade = null;
    this.itemsSimilar = [];
    let index = this.items.indexOf(item);
    this.indexAltera = index;
    this.produtoSelect =
      this.items[index].code + " " + this.items[index].product;
    this.quantidade = this.items[index].quantity;
    this.um = this.items[index].unidadem;
    if (this.isPecas) {
      this.OrcamentoViewService.getSimilar(this.items[index].code).subscribe(
        (Similar) => {
          similar = Similar;
          for (let i = 0; i < similar.length; i++) {
            this.itemsSimilar.push(
              this.OrcamentoViewService.generateNewItemSimilar(
                similar[i].similar,
                similar[i].descricao
              )
            );
          }
          this.AlteraProduto.open();
        }
      );
    } else {
      this.AlteraProduto.open();
    }
  }

  //id`,`numPedido`,`cgc`,`emissao`,`condPagamento`,`notaFiscal`,`status`,`valorTotal`,`vendedor`,`observacao`
  salvaOrcamento() {
    if (!this.altera) {
      this.router.navigate([`orcamento`], {});
      return;
    }

    if (this.total <= 0) {
      this.poNotification.setDefaultDuration(1500);
      this.poNotification.error("Favor, recalcular orçamento!");
      return;
    }

    if (!this.items || this.items.length === 0) {
      this.poNotification.setDefaultDuration(1500);
      this.poNotification.error("Orçamento sem itens");
      return;
    }

    const idOrcamento = parseInt(this.codigoOrcamento);

    this.OrcamentoViewService.getCabOrcamento(idOrcamento).pipe(
      switchMap((orc) => {
        let statusOrcamento: string;
        if (this.segmento === 'PECAS' && this.total < this.valorMinimo) {
          statusOrcamento = OrcamentoStatus.LIMITE_NAO_ATINGINDO;
        } else if (typeof orc?.numPedido === 'string' && Number(orc.numPedido.trim()) > 0) {
          statusOrcamento = OrcamentoStatus.EM_EDICAO;
        } else {
          statusOrcamento = OrcamentoStatus.EM_ELABORACAO;
        }

        this.cabOrcamento = [{
          valorTotal: this.total,
          condPagamento: this.CondpgSelect,
          observacao: this.observacao,
          status: statusOrcamento,
          id: idOrcamento,
        }];

        return this.OrcamentoViewService.SalvaCabOrcamento(this.cabOrcamento);
      }),
      switchMap((CabOrcamento) => {
        const itens: Array<any> = [];

        for (let index = 0; index < this.items.length; index++) {
          itens.push({
            idCab: this.codigoOrcamento,
            item: index + 1,
            codProduto: this.items[index].code,
            DescProduto: this.items[index].product,
            un: this.items[index].unidadem,
            quantidade: this.items[index].quantity,
            qtdLiberada: 0,
            precoTabela: this.items[index].vlruni,
            prcUnitario: this.items[index].vlruni,
            precoImposto:
              this.items[index].total / this.items[index].quantity,
            valorTotal: this.items[index].total,
            valorDesconto: 0,
          });
        }

        return this.OrcamentoViewService.SalvaItensOrcamento(itens).pipe(
          map(() => CabOrcamento)
        );
      })
    ).subscribe({
      next: (CabOrcamento) => {
        this.poNotification.success(CabOrcamento?.status || "Orçamento salvo com sucesso!");
        this.router.navigate([`orcamento`], {});
      },
      error: (err) => {
        console.error("Erro ao salvar orçamento:", err);
        this.poNotification.error("Erro ao salvar orçamento!");
      }
    });
  }

  updatePreco(): Observable<any> {
    let copyItems: Array<any> = [...this.items];
    let tabela: string = ''
    let segmento: string = sessionStorage.getItem("Segmento");

    if (
      sessionStorage
        .getItem("cpcred")
        .indexOf(this.CondpgSelect.toString()) != -1
    ) {
      tabela = sessionStorage.getItem("tabesp");
    } else {
      tabela = sessionStorage.getItem("tabprc");
    }

    // Array para guardar as requisições de preço
    let observablesArray: Array<Observable<any>> = [];

    for (let i = 0; i < copyItems.length; i++) {
      let codProduto: string = copyItems[i].code;

      // Adiciona o observable de getPreco ao array
      observablesArray.push(
        this.OrcamentoViewService.getPreco(tabela, codProduto, segmento).pipe(
          switchMap((preco) => {
            if (preco.length > 0) {
              // Calcula impostos para cada item e retorna um observable
              return from(
                this.retImpostos(
                  copyItems[i].code,
                  preco[0].precoTabela,
                  copyItems[i].quantity
                )
              ).pipe(
                map(() => {
                  if (this._impostos === undefined || this._impostos.length === 0) {
                    throw new Error("Não foi possível carregar os impostos, solicite revisão no cadastro desse produto.");
                  }

                  if (this._impostos[0].PRODUTO === "NON") {
                    this.poNotification.error(
                      "Não foi possível carregar os impostos, por favor, logue outra vez e tente novamente."
                    );
                  } else {
                    // Cria um novo item e adiciona ao array de itens
                    return this.OrcamentoViewService.generateNewItem(
                      null,
                      copyItems.length + 1,
                      copyItems[i].quantity,
                      copyItems[i].product,
                      copyItems[i].code,
                      Math.round(preco[0].precoTabela * 100),
                      Math.round(this._impostos[0].TOTAL * 100),
                      copyItems[i].unidadem,
                      0,
                      Math.round(this._impostos[0].IPI * 100),
                      Math.round(this._impostos[0].ICMS * 100),
                      0
                    );
                  }
                })
              );
            } else {
              this.poNotification.error(
                "Produto indisponível, consultar área comercial"
              );
              return of(null); // Retorna um observable nulo se não houver preço
            }
          })
        )
      );
    }

    // Retorna um Observable que espera todos os observables de preço completarem
    return forkJoin(observablesArray).pipe(
      map((result) => {
        // Filtra qualquer resultado nulo que possa ter sido gerado
        this.items = result.filter((item) => item !== null);
        this.updateTotais(); // Atualiza os totais
        return this.items; // Retorna os itens atualizados
      })
    );
  }

  copiarOrcamento() {
    let itensAtualizados: any = null;
    let tabela: string = ''

    if (
      sessionStorage
        .getItem("cpcred")
        .indexOf(this.CondpgSelect.toString()) != -1
    ) {
      tabela = sessionStorage.getItem("tabesp");
    } else {
      tabela = sessionStorage.getItem("tabprc");
    }

    this.updatePreco().subscribe({
      next: (value) => {
        itensAtualizados = value;
      },
      complete: () => {
        if (this.total > 0) {
          if (itensAtualizados.length > 0) {
            this.cabOrcamento.pop();
            const statusOrcamento = (this.total < this.valorMinimo && this.segmento === 'PECAS') ? OrcamentoStatus.LIMITE_NAO_ATINGINDO : OrcamentoStatus.EM_ELABORACAO;
            this.cabOrcamento.push({
              cgc: sessionStorage.getItem("cgc"),
              emissao: this.data,
              status: statusOrcamento,
              valorTotal: this.total,
              condPagamento: this.CondpgSelect,
              vendedor: sessionStorage.getItem("userVendedor"),
              observacao: this.observacao,
              segmto: this.segmento,
              frete: 0,
              user: sessionStorage.getItem("codeuser"),
              tabela: tabela,
            });

            this.orcamentoFormService
              .SalvaCabOrcamento(this.cabOrcamento)
              .subscribe(async (CabOrcamento) => {
                var itens: Array<any> = new Array();

                for (let index = 0; index < itensAtualizados.length; index++) {
                  itens.push({
                    idCab: CabOrcamento.id,
                    item: index.toString(),
                    codProduto: itensAtualizados[index].code,
                    DescProduto: itensAtualizados[index].product,
                    un: itensAtualizados[index].unidadem,
                    quantidade: itensAtualizados[index].quantity,
                    qtdLiberada: 0,
                    precoTabela: itensAtualizados[index].vlruni,
                    prcUnitario: itensAtualizados[index].vlruni,
                    precoImposto:
                      itensAtualizados[index].total /
                      itensAtualizados[index].quantity,
                    valorTotal: itensAtualizados[index].total,
                    valorDesconto: 0,
                  });
                }

                await this.orcamentoFormService
                  .SalvaItensOrcamento(itens)
                  .subscribe((ItensOrcamento) => { });

                this.items = itens; // Atualiza o array de itens

                this.poNotification.success("Copiado com Sucesso");
                this.router.navigate([`orcamento`], {});
              });
          } else {
            this.poNotification.setDefaultDuration(1500);
            this.poNotification.error("Orçamento sem itens");
          }
        } else {
          this.poNotification.setDefaultDuration(1500);
          this.poNotification.error("Favor, recalcular orçamento!");
        }
      },
    });
  }

  async retImpostos(Produto, ValorUni, Qtd) {
    var Dados: Array<any> = new Array();

    if (this.importacaoService.importandoItens) {
      this.isHideLoading = true;
    } else {
      this.isHideLoading = false;
    }

    var impostoItem: Impostos = new Impostos();
    impostoItem.Qtd = Qtd;
    impostoItem.ValorUni = ValorUni;
    impostoItem.Desconto = 0;
    impostoItem.Frete = 0;
    impostoItem.Produto = Produto;
    impostoItem.tpop = sessionStorage.getItem("tpop");
    impostoItem.Despesa = 0;

    Dados.push(impostoItem);

    await this.OrcamentoViewService.getImpostos(
      sessionStorage.getItem("cgc"),
      Dados
    ).then((response) => (this._impostos = response));

    this.isHideLoading = true;
  }

  async consultaSaldo(produto) {
    var Qtd = 0;
    this.saldoEstoque = null;
    await this.OrcamentoViewService.getEstoqueP(produto).then(
      (response) => (Qtd = response.QUANTIDADE)
    );
    if (Qtd > 0) {
      this.saldoEstoque = Qtd;
    }
  }

  addQtdProdutos() {
    this.quantidade += 1;
  }

  rmQtdProdutos() {
    if (this.quantidade > 0) {
      this.quantidade -= 1;
    }
  }

  closeModalAlterar: PoModalAction = {
    action: () => {
      this.AddProduto.close();
      //this.closeModal();
    },
    label: "Voltar",
    danger: true,
  };

  async addItemFromHome() {
    if (this.CondpgSelect) {
      this.produtoItems = [];
      this.produtoFiltro = null;
      if (this.produtoTemp && this.quantidadeTemp > 0) {
        console.log('Condpg', this.CondpgSelect, 'Produto', this.produtoTemp, 'Qtd', this.quantidadeTemp);
        await this.inclusaoDireta(true, []);
        this.produtoTemp = '';
        this.quantidadeTemp = 0;
        this.isHideLoading = true;
      } else {
        this.poNotification.error("Os campos de Cód. Produto e Quantidade devem ser preenchidos.");
      }
    } else {
      this.poNotification.error("Por favor, informe a condição de pagamento antes.");
    }
  }

  // Acionada ao clicar no botão
  onUploadCsv() {
    this.csvInput.nativeElement.value = ''; // Limpa seleção anterior
    this.csvInput.nativeElement.click();
  }

  async onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || !input.files.length) return;

    this.importacaoService.impOn()

    const file = input.files[0];
    const reader = new FileReader();

    reader.onload = async () => {
      const tamCabecalho = 2;
      let csv = reader.result as string;

      // === ADAPTAÇÃO PARA IGNORAR AS 2 PRIMEIRAS LINHAS ===
      // Se quiser ignorar N linhas, troque o 2 por N
      const linhas = csv.split('\n').slice(tamCabecalho - 1); // Ignora as DUAS primeiras linhas
      csv = linhas.join('\n');
      // === FIM DA ADAPTAÇÃO ===

      Papa.parse(csv, {
        header: true,
        skipEmptyLines: true,
        complete: async (result) => {
          try {
            await this.processarDadosEmLotes(result.data);
            this.produtoTemp = ''
            this.quantidadeTemp = 0
            this.poNotification.success("Importação realizada com sucesso");
          } catch (error) {
            this.poNotification.error(`Erro ao importar produtos: ${error.message}`);
          } finally {
            this.importacaoService.impOff()
          }
        },
        error: (error) => {
          this.poNotification.error(`Erro ao processar CSV: ${error.message}`);
        }
      });
    };

    reader.readAsText(file, 'UTF-8');
  }

  onBaixarModelo() {
    // Cabeçalho e observação
    const cabecalho = [['Produto', 'Quantidade']];
    const observacao = 'Aviso: Não apagar o conteudo das linhas 01 e 02. Preencher a partir da linha 03';
    const nomeArquivo = `modelo_importacao.csv`;

    // Geração do conteúdo CSV
    const csv = Papa.unparse(cabecalho, { delimiter: ";" });

    // Conteúdo final com BOM e observação
    const conteudoFinal = '\uFEFF' + observacao + '\n' + csv;

    // Criação do Blob e link de download
    const blob = new Blob([conteudoFinal], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', nomeArquivo);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }


  async processarDadosEmLotes(data: any[]) {
    const tamanhoLote = 10;
    const numeroLotes = Math.ceil(data.length / tamanhoLote);
    const errosImportacao: { linha: number, Produto: string, Quantidade: number, mensagem: string }[] = [];

    this.importacaoService.progressBarLen = data.length;

    for (let i = 0; i < numeroLotes; i++) {
      const lote = data.slice(i * tamanhoLote, (i + 1) * tamanhoLote);
      for (const [index, el] of lote.entries()) {
        try {
          this.produtoTemp = el.Produto;
          this.quantidadeTemp = Number(el.Quantidade);
          await this.inclusaoDireta(false, errosImportacao); // Passar número da linha e código do produto, se desejar
          this.importacaoService.increment()
        } catch (error) {
          for (const [index, el] of lote.entries()) {
            try {
              this.produtoTemp = el.Produto;
              this.quantidadeTemp = Number(el.Quantidade);
              await this.inclusaoDireta(false, errosImportacao);
              this.importacaoService.increment()
            } catch (error) {
              errosImportacao.push({
                linha: i * tamanhoLote + index + 1, // Linha do arquivo, começando em 1
                Produto: el.Produto,
                Quantidade: Number(el.Quantidade),
                mensagem: error.message || 'Erro desconhecido'
              });
            }
          }
        }
      }
    }

    this.importacaoService.impOff()

    if (errosImportacao.length) {
      this.poNotification.setDefaultDuration(15000);
      this.poNotification.warning(`Foram encontrados ${errosImportacao.length} erros na importação. Baixando arquivo...`);
      this.poNotification.setDefaultDuration(6000);
      this.exportarErrosParaCsv(errosImportacao);
    } else {
      this.poNotification.success('Produtos importados com sucesso!');
    }
  }

  private exportarErrosParaCsv(erros: any[]) {
    // Gera data/hora atual no formato desejado
    const agora = new Date();
    const pad = (n: number) => n.toString().padStart(2, '0');
    const dataHora =
      agora.getFullYear() + '-' +
      pad(agora.getMonth() + 1) + '-' +
      pad(agora.getDate()) + '_' +
      pad(agora.getHours()) + '-' +
      pad(agora.getMinutes()) + '-' +
      pad(agora.getSeconds());

    const nomeArquivo = `erros_importacao_${dataHora}.csv`;

    // Mensagem de observação a ser adicionada na primeira linha
    const observacao = 'Essa planilha de erros pode ser usada para importar os itens após correções adequadas';

    // Gera o conteúdo CSV dos erros normalmente
    const csv = Papa.unparse(erros, { header: true, delimiter: ";" });

    // Adiciona BOM para garantir reconhecimento do UTF-8 no Excel
    // Atenção: O BOM deve estar ANTES DE TUDO no arquivo!
    const conteudoFinal = '\uFEFF' + observacao + '\n' + csv;

    const blob = new Blob([conteudoFinal], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', nomeArquivo);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  async inclusaoDireta(mostraerro: boolean, errosImportacao: any[]) {
    if (this.importacaoService.importandoItens) {
      this.isHideLoading = true;
    } else {
      this.isHideLoading = false;
    }

    const quantidadeTemp = parseInt(this.quantidadeTemp.toString())
    const produtoTemp = this.produtoTemp;
    const condpgSelect = this.CondpgSelect;
    const segmento = this.segmento;

    this.CodigoProdutoSelect = produtoTemp;

    try {
      // Buscar informações do produto primeiro
      const produto = await firstValueFrom(
        this.orcamentoFormService.getProdutoByCodigo(produtoTemp)
      );

      if (produto.bloqueado !== 'N') {
        throw new Error("Produto bloqueado para venda!");
      }

      if (produto) {
        this.produto = produto.descricao;
        this.um = produto.un;
      } else {
        throw new Error("Produto não encontrado"); // Força cair no catch
      }

      // Continuar com o fluxo original após ter os dados do produto
      if (sessionStorage.getItem("cpcred").indexOf(condpgSelect.toString()) != -1) {
        this.tabprc = sessionStorage.getItem("tabesp");
      } else {
        this.tabprc = sessionStorage.getItem("tabprc");
      }

      if (quantidadeTemp <= 0 || isNaN(quantidadeTemp)) {
        throw new Error("Quantidade inválida: informe um valor maior que zero.");
      }

      let existe = false;

      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].code === this.CodigoProdutoSelect) {
          existe = true;
        }
      }

      if (!existe) {
        this.AddProduto.close();
        this.closeModal();

        try {
          // Obter preço
          const preco = await firstValueFrom(
            this.orcamentoFormService.getPreco(
              this.tabprc,
              this.CodigoProdutoSelect,
              segmento
            )
          );

          if (preco && preco.length > 0) {
            // Obter impostos
            await this.retImpostos(
              this.CodigoProdutoSelect,
              preco[0].precoTabela,
              quantidadeTemp
            );

            if (this._impostos === undefined || this._impostos.length === 0) {
              throw new Error("Não foi possível carregar os impostos, solicite revisão no cadastro desse produto.");
            }

            if (this._impostos[0].PRODUTO == "NON") {
              // Se quiser, pode lançar erro personalizado aqui também
              throw new Error("Não foi possível carregar os impostos, por favor, logue outra vez e tente novamente.");
            } else {
              if (this.desconto === undefined || this.desconto === null) {
                this.desconto = 0;
              }

              this.items.push(
                this.orcamentoFormService.generateNewItem(
                  this.items.length + 1,
                  quantidadeTemp,
                  this.produto,
                  this.CodigoProdutoSelect,
                  Math.round(preco[0].precoTabela * 100),
                  Math.round(this._impostos[0].TOTAL * 100),
                  this.um,
                  Math.round(this.desconto * 100),
                  Math.round(this._impostos[0].IPI * 100),
                  Math.round(this._impostos[0].ICMS * 100),
                  // this._impostos[0].TOTAL * quantidadeTemp
                )
              );
              this.updateTotais();
            }
            this.AddProduto.close();
          } else {
            // Produto não retornou preço, pode lançar erro específico
            this.AddProduto.close();
            this.closeModal();
            throw new Error("Produto indisponível, consultar área comercial");
          }
        } catch (error) {
          this.AddProduto.close();
          this.closeModal();
          // Aqui você apenas relança o erro para ser tratado pelo try/catch mais externo
          throw error;
        }
      } else {
        this.AddProduto.close();
        this.closeModal();
        throw new Error("Produto adicionado anteriormente!");
      }

      this.AddProduto.close();
    } catch (error) {
      let mensagemErro = "Erro inesperado";

      // Tratamento robusto do erro
      if (error instanceof Error && error.message) {
        mensagemErro = error.message;
      } else if (error && typeof error === 'object') {
        if ('error' in error && error.error) {
          if (typeof error.error === 'string') {
            mensagemErro = error.error;
          } else if (typeof error.error === 'object' && error.error.message) {
            mensagemErro = error.error.message;
          }
        } else if ('message' in error && error.message) {
          mensagemErro = error.message;
        }
      } else if (typeof error === 'string') {
        mensagemErro = error;
      }
      if (
        mensagemErro === 'Erro inesperado' &&
        error &&
        error.status === 404
      ) {
        mensagemErro = "Produto não encontrado";
      }

      if (mostraerro) {
        this.poNotification.error(mensagemErro);
        this.AddProduto.close();
      } else {
        console.error('Erro ao buscar produto:', error);
      }

      errosImportacao.push({
        Produto: produtoTemp,
        Quantidade: quantidadeTemp,
        mensagem: mensagemErro
      });
    } finally {
      this.isHideLoading = true; // Sempre ao final, com sucesso ou erro!
    }
  }
}
